import React from 'react'
import { ExitTypo, Header, LogoTypo, Span, StepsTypo, StepsValue } from '../../CourseCreationFlow/styles'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Box } from '@mui/material'
import ProgressBar from '../ProgressBar/progressbar'
import { eduAccFlowHeaderSx } from './styles'

export const EduAccFlowHeader = ({ handleExit, steps }) => {
  return (
    <div>
      <Header alignItems={"center"}>
        <Grid container sx={eduAccFlowHeaderSx.container}>
          <Grid lg={2} md={2} sm={3} xs={3}>
            <Box sx={eduAccFlowHeaderSx.logoBox}>
              <Span>
                <LogoTypo color={"primary"} variant="h4" onClick={handleExit}>
                  Vulcan
                </LogoTypo>
              </Span>
            </Box>
          </Grid>
          <Grid lg={7} md={6} sm={6} xs={6} sx={eduAccFlowHeaderSx.stepsGrid}>
            <StepsTypo variant="h6">
              Step {steps} of 4{steps === 1 ? "" : ":"} 
              <StepsValue sx={eduAccFlowHeaderSx.stepsValue} ml={2} style={{ paddingLeft: "10px" }}>
                {steps === 1 ? "" : (steps === 2 ? "Experience" : (steps === 3 ? "Reach" : (steps === 4 ? "Profile" : "")))}
              </StepsValue>
            </StepsTypo>
          </Grid>
          <Grid lg={2} md={2} sm={2} xs={2} sx={eduAccFlowHeaderSx.exitGrid}>
            <Span>
              <ExitTypo variant="h6" color="primary" onClick={handleExit}>
                Exit
              </ExitTypo>
            </Span>
          </Grid>
        </Grid>
        <ProgressBar componentName={"eduSteps"} />
      </Header>
    </div>
  )
}
